<div class="container-fluid">
  <app-report reportId="productsReport" screen="ProductDetail" [params]="params"></app-report>
</div>